import React, { FC, useState } from 'react';
import { CardImage, LandscapeImageContainer, MoviePortraitImageWrapper } from 'style/styled-components/reusable.css';
import { InsetPortraitImage, MediaBackdrop } from 'components/Cards/Card/Card.css';

type PropTypes = {
    image: string;
    customImage?: string;
    landscape?: boolean;
    fallbackImage?: string;
    insetFallbackImage?: string;
    showInsetPortrait?: boolean;
    blurBackdrop?: boolean;
};

export const CardMedia: FC<PropTypes> = ({
    image,
    customImage,
    landscape = false,
    fallbackImage,
    insetFallbackImage,
    showInsetPortrait = true,
    blurBackdrop = false,
}) => {
    const [insetImageError, setInsetImageError] = useState<boolean>(false);
    const showInset = showInsetPortrait && !!image && !landscape && !insetImageError;

    const media = <CardImage url={customImage || image} fallbackImage={fallbackImage} alt="" />;

    return (
        <>
            <LandscapeImageContainer>
                {blurBackdrop ? <MediaBackdrop isBackgroundBlur={showInset}>{media}</MediaBackdrop> : media}
            </LandscapeImageContainer>
            {showInset && (
                <MoviePortraitImageWrapper>
                    <InsetPortraitImage>
                        <CardImage
                            url={image}
                            fallbackImage={insetFallbackImage}
                            alt=""
                            {...{
                                imageError: () => {
                                    setInsetImageError(true);
                                },
                            }}
                        />
                    </InsetPortraitImage>
                </MoviePortraitImageWrapper>
            )}
        </>
    );
};
